/* eslint-disable prefer-promise-reject-errors */
import rout from "../../router";
import { logInReq } from "../../axiosfiles/axios-outh";

export const state = {
  tokenID: null,
  rToken: null,
};
export const mutations = {
  OnLogIn(state, token) {
    state.tokenID = token;
    state.rToken = sessionStorage.getItem("MashToken2");
  },
  OnLogout(state) {
    state.tokenID = null;
    sessionStorage.removeItem("MashToken");
    sessionStorage.removeItem("MashToken2");
    state.rToken = null;
    if (rout.currentRoute.name !== "login") rout.push("/login");
  },
};
export const actions = {
  AutoLogin({ commit }) {
    const token = sessionStorage.getItem("MashToken");
    commit("OnLogIn", token);
  },
  login({ commit }, LoginUser) {
    return new Promise((resolve, rejects) => {
      logInReq
        .post("/login", LoginUser)
        .then(user => {
          // console.log(user);
          commit("OnLogIn", user.data.token);

          sessionStorage.setItem("MashToken", user.data.token);
          sessionStorage.setItem("MashToken2", user.data.rToken);
          rout.push("/");
          resolve("good");
        })
        .catch(err => {
          rejects(err);
        });
    });
  },
};
export const getters = {
  isAuthenticated(state) {
    const token = sessionStorage.getItem("MashToken");
    state.tokenID = token;
    return state.tokenID !== null;
  },
  showToken(state) {
    let tID = state.tokenID;
    const token = sessionStorage.getItem("MashToken");
    if (tID === token && token != null) return tID;
    else return null;
  },
  showRtoken() {
    let tID = state.rToken;
    const token = sessionStorage.getItem("MashToken2");
    // console.log(tID);
    // if (tID === token) return tID;
    // else return null;
    return tID || token;
  },
};
